var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35528 13.214V13.0041C3.38607 12.3832 3.58507 11.7816 3.93175 11.2613C4.50881 10.6364 4.90383 9.87051 5.07538 9.04411C5.07538 8.40541 5.07538 7.75757 5.13117 7.11887C5.41941 4.04395 8.4598 1.91797 11.463 1.91797H11.5374C14.5406 1.91797 17.581 4.04395 17.8785 7.11887C17.9343 7.75757 17.8785 8.40541 17.925 9.04411C18.0989 9.87243 18.4935 10.6407 19.0686 11.2705C19.4179 11.7861 19.6172 12.3855 19.6451 13.0041V13.2048C19.6659 14.039 19.3786 14.8524 18.8362 15.4951C18.1195 16.2465 17.1469 16.7139 16.1026 16.809C13.0404 17.1375 9.95073 17.1375 6.88847 16.809C5.84534 16.7098 4.87418 16.243 4.1549 15.4951C3.62091 14.8519 3.33747 14.0434 3.35528 13.214Z",
    stroke: "#FE706F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15723 19.9844C9.6357 20.5849 10.3383 20.9736 11.1096 21.0644C11.8809 21.1551 12.6573 20.9405 13.2669 20.468C13.4544 20.3282 13.6231 20.1657 13.769 19.9844",
    stroke: "#FE706F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPink);
export default __webpack_public_path__ + "static/media/notification-pink.8d47b32546620165d15e7e36368288d7.svg";
export { ForwardRef as ReactComponent };